

import { all, call, put, take } from 'redux-saga/effects'
import * as api from '../services/api'
import { STATUS } from '../modules/constants'
import { isSameDate } from '../modules/utilities'
import { API_CALLS, CORE_ENTITIES, DATA_SANITY_CHECKS, TIME_STAMPS } from '../modules/synopsisConstants'

const initialState = {
  status: { data: {} },
  synopsis: null,
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'synopsis.get': {
      // console.log('synopsis.get action: ', action)
      return {
        ...state,
      }
    }

    case 'synopsis.set': {
      // console.log('synopsis.set action: ', action)
      return {
        ...state,
        data: action.data,
      }
    }

    default: {
      return state
    }
  }
}

// Watcher saga: get revise and get data
export function* watchReviseSynopsis() {
  while (true) {
    // console.log("watchReviseSynopsis")
    yield take('synopsis.revise')
    yield call(api.synopsis.reviseSynopsis)
    yield put(actions.get())
  }
}

// Watcher saga: get synopsis data
export function* watchGetSynopsis() {


  while (true) {
    yield take('synopsis.get')
    const synopsis = yield call(api.synopsis.getSynopsis)
    // console.log("synopsis", synopsis)

    const data = {
      general: { values: {}, status: {} },
      api: {
      },
    }

    var companies = [API_CALLS.NUMERABLE.ID, API_CALLS.CLUB350.ID]

    companies.forEach(company => {
      data.api[company] = {
        companies: { values: {}, status: {} },
        newsMeta: { values: {}, status: {} },
        newsRelease: { values: {}, status: {} },
      }
    })

    // Function to set values and status for each synopsis property
    const SetValuesAndStatus = ({ name, props, sector, synopsis }) => {
      // console.log("props", props)
      const { bad, key, max, min } = props

      if (synopsis) {
        var value = synopsis[key]
        // console.log("value", value)
        if (typeof (value) === 'number') {
          sector.values[name] = value
          sector.status[name] = (min === null ? true : value >= min) && (max === null ? true : value <= max)
            ? STATUS.GOOD : !!bad ? STATUS.BAD : STATUS.WARN
        } else {
          sector.values[name] = new Date(value)
          sector.status[name] = isSameDate(new Date(value), new Date()) ? STATUS.GOOD : !!bad ? STATUS.BAD : STATUS.WARN
        }
      }
    }

    {
      // SetValuesAndStatus({ prop: SYNOPSIS.BOARD_ROLES }) etc.
      Object.entries(TIME_STAMPS).forEach(([name, props]) => {
        SetValuesAndStatus({ name, props, sector: data.general, synopsis: synopsis.timeStamps })
      })

      Object.entries(CORE_ENTITIES).forEach(([name, props]) => {
        SetValuesAndStatus({ name, props, sector: data.general, synopsis: synopsis.coreEntities })
      })

      Object.entries(DATA_SANITY_CHECKS).forEach(([name, props]) => {
        SetValuesAndStatus({ name, props, sector: data.general, synopsis: synopsis.dataSanityChecks })
      })
    }

    // const apiCapiCalls = ({ source, company, id }) => {
    //   // console.log(`synopsis[${id}]`, synopsis[id])
    //   Object.entries(source).forEach(([name, props]) => {
    //     console.log(`synopsis: synopsis[${company}][${id}]`, synopsis[company][id])
    //     SetValuesAndStatus2({ name, props, sector: data.api[company][id], value: synopsis[company][id].count })
    //     // SetValuesAndStatus({ name, props, sector: data.api.companies, synopsis: synopsis[id].companies })
    //   })
    // }

    // apiCapiCalls({ source: NUMERABLE_API_CALLS, company: 'numerableApiCalls', id: 'companies' })

    var companyId = API_CALLS.CLUB350.ID
    Object.entries(API_CALLS.CLUB350.COMPANIES).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].companies, synopsis: synopsis.club350ApiCalls.companies })
    })

    Object.entries(API_CALLS.CLUB350.NEWS_META).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].newsMeta, synopsis: synopsis.club350ApiCalls.newsMeta })
    })

    Object.entries(API_CALLS.CLUB350.NEWS_RELEASE).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].newsRelease, synopsis: synopsis.club350ApiCalls.newsRelease })
    })

    // ------------------------------------------------------------------------
    var companyId = API_CALLS.NUMERABLE.ID
    Object.entries(API_CALLS.NUMERABLE.COMPANIES).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].companies, synopsis: synopsis.numerableApiCalls.companies })
    })

    Object.entries(API_CALLS.NUMERABLE.NEWS_META).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].newsMeta, synopsis: synopsis.numerableApiCalls.newsMeta })
    })

    Object.entries(API_CALLS.NUMERABLE.NEWS_RELEASE).forEach(([name, props]) => {
      SetValuesAndStatus({ name, props, sector: data.api[companyId].newsRelease, synopsis: synopsis.numerableApiCalls.newsRelease })
    })
    // ------------------------------------------------------------------------

    // Overall status is the worst status among all metrics, gathered by recursing into every
    // sector - data.api nests a "status" object per company per endpoint (data.api[company].newsRelease.status
    // etc), not just at the top level like data.general.status, so a single-level walk misses them
    const collectStatuses = sector => {
      if (!sector || typeof sector !== 'object') return []
      const ownStatuses = sector.status ? Object.values(sector.status) : []
      const nestedStatuses = Object.entries(sector)
        .filter(([key, value]) => key !== 'status' && key !== 'values' && value && typeof value === 'object')
        .flatMap(([, value]) => collectStatuses(value))
      return [...ownStatuses, ...nestedStatuses]
    }

    data.overall = Math.max(...collectStatuses(data))

    // yield put(actions.set({ status, values }))
    yield put(actions.set({ data }))
  }
}

//#region actions, selectors and sagas
export const actions = {
  get: props => ({ type: 'synopsis.get', ...props }),
  set: props => ({ type: 'synopsis.set', ...props }),
  revise: props => ({ type: 'synopsis.revise', ...props }),
}

export const selectors = {}

export function* sagas() {
  yield all([
    watchGetSynopsis(),
    watchReviseSynopsis(),
  ])
  //#endregion
}
